import { useFormik } from "formik";
import TextInput from "../../../components/inputs/textInput";
import Button from "../../../components/buttons/button";
import { useTranslation } from "react-i18next";

const CylindricalParcelCalculator = () => {
  const formik = useFormik({
    initialValues: {
      parcels: "",
      radius: "",
      height: "",
    },
    onSubmit: (values) => {
      const { radius, height, parcels } = values;

      const r = parseFloat(radius);
      const h = parseFloat(height);
      const p = parseInt(parcels);

      if (!isNaN(r) && !isNaN(h) && !isNaN(p)) {
        const volumePerParcel = (Math.PI * Math.pow(r, 2) * h) / 1000000;
        const totalVolume = volumePerParcel * p;

        formik.setFieldValue("totalVolume", totalVolume.toFixed(3));
      } else {
        formik.setFieldValue("totalVolume", "Invalid input");
      }
    },
  });
  const { t } = useTranslation();
  return (
    <article className="p-4 bg-white rounded-2xl shadow-mainShadow">
      <h3 className="text-xl font-bold text-center text-mainBlue">
        {t("VolumeOfCylindricalParcels")}
      </h3>

      <form onSubmit={formik.handleSubmit}>
        <TextInput
          label={t("numberOfParcels")}
          formik={formik}
          name={"parcels"}
          placeholder={""}
          number
        />
        <TextInput
          label={t("baseRadius")}
          formik={formik}
          name={"radius"}
          placeholder={""}
          number
        />
        <TextInput
          label={t("height")}
          formik={formik}
          name={"height"}
          placeholder={""}
          number
        />
        <Button text={t("volumeCalculation")} className={"w-full bg-mainRed my-4"} />
        <TextInput
          label={t("totalVolumeM")}
          formik={formik}
          name={"totalVolume"}
          placeholder={""}
          disabled
        />
      </form>
    </article>
  );
};

export default CylindricalParcelCalculator;
